"use client";
import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
    label?: string;
}

const Button: React.FC<ButtonProps> = ({
    children,
    loading = false,
    disabled,
    className,
    label,
    ...props
}) => {
    return (
        <button
            {...props}
            disabled={loading || disabled}
            className={`w-full bg-gradient-to-r from-sky-600 to-sky-500 text-white py-3 px-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none ${className || ""
                }`}
        >
            {loading ? (
                <div className="flex items-center justify-center">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    {label}
                </div>
            ) : (
              children
            )}
        </button>
    );
};

export default Button;
